"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _addPop = _interopRequireDefault(require("../home/components/addPop.vue"));
var _customPage = require("@/api/customPage");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'AppNewRenovationHone',
  components: {
    addPop: _addPop.default
  },
  data: function data() {
    return {
      page: 1,
      size: 10,
      total: 1,
      title: '',
      tableList: []
    };
  },
  created: function created() {
    this.findList();
  },
  methods: {
    cloneAdmin: function cloneAdmin() {
      var _this = this;
      this.$confirm('确认是否克隆系统模板?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _customPage.cloneDefaultTemplate)({
          type: 2
        }).then(function (res) {
          if (res.data) {
            _this.$notify.success({
              title: '温馨提示',
              message: '操作成功'
            });
            _this.findList();
          }
        });
      });
    },
    reset: function reset() {
      this.title = '';
      this.page = 1;
      this.findList();
    },
    search: function search() {
      this.page = 1;
      this.findList();
    },
    findList: function findList() {
      var _this2 = this;
      (0, _customPage.getList)({
        page: this.page,
        size: this.size,
        name: this.title,
        type: 2
      }).then(function (res) {
        _this2.tableList = res.data.data;
        _this2.total = res.data.total;
      });
    },
    goRenovation: function goRenovation(val) {
      this.$router.push({
        path: '/appNewRenovation/userCenter/renovation',
        query: {
          activityName: val.name,
          id: val.pageId
        }
      });
    },
    onRefresh: function onRefresh(val) {
      if (val === 'add') {
        this.page = 1;
      }
      this.findList();
    },
    onAdd: function onAdd() {
      this.$refs.addPop.open({
        type: 'add',
        title: '模板添加'
      });
    },
    del: function del(val) {
      var _this3 = this;
      this.$confirm('是否确认删除此自定义页面?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _customPage.deletePage)({
          pageId: val.pageId,
          type: 2
        }).then(function (res) {
          if (res.data) {
            _this3.$notify.success({
              title: '温馨提示',
              message: '操作成功'
            });
            _this3.findList();
          }
        });
      });
    },
    clone: function clone(val) {
      var _this4 = this;
      this.$confirm('确认克隆当前模板?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _customPage.clone)({
          pageId: val.pageId
        }).then(function (res) {
          if (res.data) {
            _this4.$notify.success({
              title: '温馨提示',
              message: '操作成功'
            });
            _this4.findList();
          }
        });
      });
    },
    detail: function detail(val) {
      this.$refs.addPop.open({
        type: 'upDate',
        name: val.name,
        id: val.pageId,
        title: '编辑模板信息'
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.size = val;
      this.findList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.findList();
    }
  }
};